// extracted by mini-css-extract-plugin
export default {"form":"Form_form__1Ye0b","errorFooter":"Form_errorFooter__iyb4p"};